/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown> }} Booking_Portal_Names_AndInputs */

const en_booking_portal_names_and = /** @type {(inputs: Booking_Portal_Names_AndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} and ${i?.last}`)
};

const pl_booking_portal_names_and = /** @type {(inputs: Booking_Portal_Names_AndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} i ${i?.last}`)
};

/**
* | output |
* | --- |
* | "{first} and {last}" |
*
* @param {Booking_Portal_Names_AndInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_names_and = /** @type {((inputs: Booking_Portal_Names_AndInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Names_AndInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_names_and(inputs)
	return en_booking_portal_names_and(inputs)
});